import { CaptionModule } from './../caption/caption.module';
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TopnavComponent } from "./topnav.component";
import { TopnavitemComponent } from "./topnavitem/topnavitem.component";
import { InputModule } from "../input/input.module";
import { IconModule } from "../icon/icon.module";
import { MenuModule } from "../menu/menu.module";
import { RouterModule } from "@angular/router";

@NgModule({
	declarations: [TopnavComponent, TopnavitemComponent],
	imports: [CommonModule, InputModule, IconModule, MenuModule, RouterModule, FormsModule, CaptionModule],
	exports: [TopnavComponent, TopnavitemComponent]
})
export class TopnavModule {}
